import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import NavigationCard from 'Views/Onboarding/Components/Navigation/NavigationCard';
import NavigationHeader from 'Views/Onboarding/Components/Navigation/NavigationHeader';
import LogoutButton from 'Views/Onboarding/Components/Navigation/LogoutButton';

const styles = (theme) => ({
  root: {
  },
  fullFlexColumn: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  header: {
    width: '100%',
    padding: theme.spacing(2.25),
  },
  content: {
    padding: theme.spacing(2.25),
    backgroundColor: theme.palette.facet.backgroundGray,
  },
  moduleCardContainer: {
    marginTop: theme.spacing(1),
    flexGrow: 1,
    width: '100%',
  },
  footer: {
    width: '100%',
    borderTop: `1px solid ${theme.palette.facet.border}`,
    paddingTop: theme.spacing(1),
  },
});

const NavigationDrawerContent = ({
  className,
  classes,
  toggleDrawer,
  clientResource,
  navigationResource,
  onCardClick,
  canLogout,
}) => {
  // TODO skeleton?
  if (!navigationResource) return null;
  return (
    <div className={classNames(classes.root, classes.fullFlexColumn, className)}>
      <div className={classes.header}>
        {toggleDrawer ? (
          <IconButton onClick={toggleDrawer} test="survey-nav-close">
            <CloseIcon />
          </IconButton>) : null
        }
        <NavigationHeader clientResource={clientResource} navigationResource={navigationResource} />
      </div>
      <div className={classNames(classes.fullFlexColumn, classes.content)}>
        <div className={classes.moduleCardContainer}>
          {navigationResource.attr('listItems').resources().list().map(el => (
            <NavigationCard
              key={`nav-card-${el.id()}`}
              resource={el}
              onClick={onCardClick}
              toggleDrawer={toggleDrawer}
            />
          ))}
        </div>
        {canLogout ? (
          <div className={classes.footer}>
            <LogoutButton />
          </div>) : null
        }
      </div>
    </div>
  );
};

NavigationDrawerContent.defaultProps = {
  className: '',
  canLogout: true,
};

NavigationDrawerContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  clientResource: PropTypes.object.isRequired,
  navigationResource: PropTypes.object.isRequired,
  onCardClick: PropTypes.func.isRequired,
  canLogout: PropTypes.bool,
};

export default withStyles(styles)(NavigationDrawerContent);
